import { connect } from "react-redux";

import HeaderButtons from "./HeaderButtons.view";
import { withRouter } from "react-router-dom";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HeaderButtons)
);
